import {
    TOUR_AWAITED_ACTION_LIST_SUCCESS,
    TOUR_AWAITED_ACTION_LIST_ERROR,
    TOUR_AWAITED_ACTION_LIST_START,
} from '../Constants/TourAwaitedListConstant'
const initialState = {
    loading: false,
    awaitedActionList: [],
    awaitedLoading: false,

};

export default function TourAwaitedListReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case TOUR_AWAITED_ACTION_LIST_START:
            return {
                ...state,
                awaitedLoading: true,
            };
        case TOUR_AWAITED_ACTION_LIST_SUCCESS:
            return {
                ...state,
                awaitedActionList: action.payload,
                awaitedLoading: false,
            };
        case TOUR_AWAITED_ACTION_LIST_ERROR:
            return {
                ...state,
                awaitedLoading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}
